'use client';
import { ensureNativeModulesAreInstalled } from './ensureNativeModulesAreInstalled';
ensureNativeModulesAreInstalled();
export const EventEmitter = globalThis.expo.EventEmitter;

//# sourceMappingURL=EventEmitter.js.map
